import React from "react";
import { CheckboxEditor } from "../../../../../../../../../react-core/Html/CheckboxEditor";
import { FormComponent } from "../../../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../../../react-core/Html/PartLoading";
import { UserClaim } from "../../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { ClientAccount } from "../../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { Permission } from "../../../../../../../../Shared/Permission/Permission";
import { portfolioDashboardRolesAction } from "../../Action/Action";

interface IReportOptOutProps {
    clAccountId: string;
}

interface IReportOptOutState {
    isOptOut: boolean;
    OriginalIsOptOut: boolean;
    isEdit: boolean;
}

export class ReportOptOut extends FormComponent<IReportOptOutProps, IReportOptOutState> {
    constructor(props: IReportOptOutProps) {
        super(props);
        this.state = {
            isOptOut: null,
            OriginalIsOptOut: null,
            isEdit: false,
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        portfolioDashboardRolesAction.getReportOptOutSetting(this.props.clAccountId, (result) => {
            this.setState({ isOptOut: result.IsOptOut, OriginalIsOptOut: result.IsOptOut });
        });
    }

    private saveSetting() {
        this.setState({ isOptOut: null, isEdit: false });
        portfolioDashboardRolesAction.updateReportOptOutSetting(
            this.props.clAccountId,
            this.state.isOptOut,
            (result) => {
                this.getData();
            }
        );
    }

    render() {
        const { isOptOut, OriginalIsOptOut, isEdit } = this.state;

        if (isOptOut == null) {
            return <PartLoading isLoading={true} />;
        }
        return (
            <>
                <h4>Client has opt out of receiving</h4>
                {!isEdit && (
                    <dl className="def-list">
                        <dt>Contract note</dt>
                        <dd>{isOptOut == true ? "Yes" : "No"}</dd>
                    </dl>
                )}
                {isEdit && (
                    <CheckboxEditor
                        label="Contract note"
                        cssWrapper="square-checkbox block mt-19"
                        value={isOptOut}
                        onChange={(v) => this.setState({ isOptOut: v })}
                        disabled={!isEdit}
                    />
                )}
                <Permission userClaim={UserClaim.AdviserPortalPortfolioViewRolesReadWrite}>
                    <div>
                        <div className="row row-center">
                            {!isEdit && (
                                <div className="col-auto">
                                    <button
                                        className="edit-circle-icon-button label-sr-only"
                                        title="Edit"
                                        onClick={() => this.setState({ isEdit: true })}
                                    >
                                        <span className="icon" aria-hidden="true"></span>
                                        <span className="text">Edit</span>
                                    </button>
                                </div>
                            )}
                            {isEdit && (
                                <div className="col-auto">
                                    <button
                                        className="button mr-20"
                                        onClick={(val) => this.setState({ isEdit: false, isOptOut: OriginalIsOptOut })}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            )}
                            {isEdit && (
                                <div className="col-auto">
                                    <button className="button" onClick={(val) => this.saveSetting()}>
                                        Save
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </Permission>
            </>
        );
    }
}
